<template>
  <div class="retail">
    <Tabs
      title="Розничные заказы"
      :tabs="tabs"
      :active="tabActive"
      @tabActiveUpdate="updateOrdersTab"
      class="tab--table">
      <Journal
        v-if="tabActive === tabs[0].path"
        :inputId="'retail'"
        :retail="true"
        :isSelectedList="true"
        :list="retail ? retail.data : []"
        :pagination="retail ? retail.pagination : null"
        :tabActive="tabActive"
        @updateJournal="updateOrders">
      </Journal>
      <Journal
        v-if="tabActive === tabs[1].path"
        :inputId="'retail-archived'"
        :retail="true"
        :archived="true"
        :list="retailArchived ? retailArchived.data : []"
        :pagination="retailArchived ? retailArchived.pagination : null"
        :tabActive="tabActive"
        @updateJournal="updateOrders">
      </Journal>
    </Tabs>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { ORDER_TYPE } from "@/store/modules/account/variables";
import Orders from "@/mixins/Account/orders.mixin";

export default {
  name: "AccountOrdersRetail",

  components: {
    Tabs: () => import('@/pages/account/components/Tabs'),
    Journal: () => import('./components/journal/Journal'),
  },

  mixins: [
    Orders,
  ],

  metaInfo () {
    return {
      title: `Розничные заказы - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  data: () => ({
    type: ORDER_TYPE.retail,
  }),

  computed: {
    ...mapState({
      retail: state => state.account.orders.retail,
      retailArchived: state => state.account.orders.retailArchived,
      retailSubdealers: state => state.account.orders.retailSubdealers,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },
}
</script>
<style scoped lang="scss">
</style>